import classNames from 'classnames';
import * as React from 'react';

import * as styles from './Logo.css';

interface ILogoProps {
  url: string;
  noResize: boolean;
}

export const Logo: React.FC<ILogoProps> = ({ noResize, url }) => {
  return <a href={url} className={classNames(styles['container'], noResize && styles['static'])} />;
};
